import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Nav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sections/ContactSection.tsx");
